import { render, staticRenderFns } from "./LProjectObjectQuestions.vue?vue&type=template&id=2dbb2066&scoped=true&"
import script from "./LProjectObjectQuestions.vue?vue&type=script&lang=js&"
export * from "./LProjectObjectQuestions.vue?vue&type=script&lang=js&"
import style0 from "./LProjectObjectQuestions.vue?vue&type=style&index=0&id=2dbb2066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb2066",
  null
  
)

export default component.exports